<template>
  <div
    id="$address-book$"
    class="width-full height-full bg-F6F6F6 bt address-book"
  >
    <!-- 查看详情 -->
    <div v-if="showSelectDetail" class="width-full height-full fb fb-col">
      <div class="item-flex-1 scroll" refs="scroller">
        <template v-if="computedSelectedDept.length">
          <div
            v-for="item in computedSelectedDept"
            :key="item.deptDingId"
            class="bg-FFFFFF h-56 lh-56 fb fb-cross-center fb-main-between p-0-16"
          >
            <div class="c-171A1D text-ellipsis max-w-220 font-34 h-36 lh-36"
              >{{ item.deptName
              }}<span
                v-show="item.hasChildren && item.data.classSelCnt"
                :class="['ml-8 c-006AFE']"
                >({{ item.data.classSelCnt }})</span
              ></div
            >
            <i
              class="iconfont font-40 c-171A1D-40"
              @click.stop="clearNodes(item)"
              >&#xe670;</i
            >
          </div>
        </template>
        <template v-if="computedSelectedClass.length">
          <div class="font-36 group-title c-191F25-40"> 班级 </div>
          <div
            v-for="item in computedSelectedClass"
            :key="item.deptDingId"
            class="bg-FFFFFF h-56 lh-56 fb fb-cross-center fb-main-between p-0-16"
          >
            <div class="c-171A1D text-ellipsis max-w-220 font-34 h-36 lh-36">{{
              item.deptName
            }}</div>
            <i
              class="iconfont font-40 c-171A1D-40"
              @click.stop="clearNodes(item)"
              >&#xe670;</i
            >
          </div>
        </template>
      </div>
      <div class="bt p-8-0 bg-FFFFFF p-0-16 fb fb-main-center fb-cross-center">
        <span
          @click="clearData"
          class="inline-block item-flex-1 mr-8 h-46 c-171A1D text-center font-36 bd-radio-12 lh-46 bg-171A1D-8"
          >清空</span
        >
        <span
          @click="confirmDetail"
          class="inline-block item-flex-1 h-46 c-FFFFFF text-center font-36 bd-radio-12 lh-46 bg-006AFE"
          >确定</span
        >
      </div>
    </div>
    <!-- 通讯录页面 -->
    <div v-else class="width-full height-full fb fb-col">
      <!-- 成员搜索输入框 -->
      <common-search-input-box
        v-show="nodeNav && nodeNav.length > 1"
        class="p-8-0 p-0-8 bg-FFFFFF"
        placeholder="搜索班级"
        :delay="1000"
        :searchValue="searchKey"
        @search="handlerToSearch"
        @focus="handlerToFocusSearch"
        @blur="isFocus = false"
      ></common-search-input-box>
      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="nodeNav.length > 0 && !this.searchKey"
        :nodeNav="nodeNav"
        @click="handlerBackToNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-show="computedIsShowSelectAll"
        class="h-56 fb fb-row fb-start-center font-34 bg-FFFFFF p-0-16 mb-8"
      >
        <common-checkbox
          :class="{ 'c-171A1D-28': computedIsDisabledSelectAll }"
          :isChecked="!computedIsDisabledSelectAll && compuedIsSelectedAll"
          @click="handlerToChangeSelections"
          ><span class="ml-12">全选</span></common-checkbox
        >
      </div>
      <div class="item-flex-1 scroll">
        <!-- 搜索结果部门列表 -->
        <div v-show="searchKey" class="node-list h-full font-34">
          <div
            v-show="searchNodes.length === 0"
            class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
          >
            <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
            <span class="font-26">没有符合搜索条件的记录</span>
          </div>
          <div
            class="fb fb-row fb-cross-center h-56 lh-56 pl-16 bg-FFFFFF hidden-x"
            v-for="(node, index) in searchNodes"
            :key="index"
          >
            <div
              class="mr-12"
              @click="
                handlerChangeClassSelected(node, !node.classCnt, searchKey)
              "
              ><span
                class="iconfont font-48"
                :class="node.selectStatus ? 'c-006AFE' : 'c-171A1D-24'"
                >{{ node.selectStatus ? '&#xe66e;' : '&#xe66f;' }}</span
              ></div
            >
            <div
              class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16 hidden-x"
            >
              <div
                class="item-flex-1 fb fb-cross-center"
                @click="
                  handlerChangeClassSelected(node, !node.classCnt, searchKey)
                "
                ><span
                  :class="[
                    'text-ellipsis inline-block max-w-150',
                    !node.classCnt ? 'c-171A1D-28' : 'c-171A1D'
                  ]"
                  >{{ node.deptName }}</span
                >
                <span
                  v-show="node.hasChildren && node.classCnt"
                  :class="[
                    'ml-8',
                    node.classCnt
                      ? node.classSelCnt
                        ? 'c-006AFE'
                        : 'c-171A1D-40'
                      : 'c-171A1D-28'
                  ]"
                  >({{ node.classSelCnt }}/{{ node.classCnt }})</span
                ></div
              >
            </div>
          </div>
        </div>
        <!-- 子级部门列表、部门成员列表 -->
        <div
          v-show="!searchKey && treeNodes && treeNodes.length"
          class="node-list item-flex-1 bg-FFFFFF font-34"
        >
          <!-- 子级部门列表 -->
          <div
            v-for="node in treeNodes"
            class="fb-start-center h-56 lh-56 pl-16 hidden-x"
            :key="node.deptDingId"
          >
            <span
              class="mr-16"
              :class="[
                'iconfont font-48',
                !node.classCnt
                  ? 'c-171A1D-12'
                  : node.selectStatus
                  ? 'c-006AFE'
                  : 'c-171A1D-40'
              ]"
              @click="handlerChangeClassSelected(node, !node.classCnt)"
            >
              {{ node.selectStatus ? '&#xe66e;' : '&#xe66f;' }}
            </span>
            <div
              class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16 hidden-x"
            >
              <div
                class="item-flex-1 fb fb-cross-center hidden-x"
                @click="handlerChangeClassSelected(node, !node.classCnt)"
                ><span
                  :class="[
                    'text-ellipsis inline-block w-adapt-72',
                    !node.classCnt ? 'c-171A1D-28' : 'c-171A1D'
                  ]"
                  >{{ node.deptName }}</span
                >
                <span
                  v-show="node.hasChildren && node.classCnt"
                  :class="[
                    'ml-8',
                    node.classCnt
                      ? node.classSelCnt
                        ? 'c-006AFE'
                        : 'c-171A1D-40'
                      : 'c-171A1D-28'
                  ]"
                  >({{ node.classSelCnt }}/{{ node.classCnt }})</span
                ></div
              >
              <div class="c-006AFE font-34 item-shrink-0">
                <span
                  class="bl-12 pl-9"
                  v-if="node.hasChildren"
                  @click.stop="handlerToGetSubNodes(node)"
                >
                  <i class="iconfont">&#xe714;</i>下级
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="font-26 fb fb-cross-center fb-main-between h-46 bg-FFFFFF p-0-16 bt-8"
      >
        <div class="item-flex-1 c-006AFE" @click.stop="handlerViewDetail">
          已选择: {{ classCount }}个班级
          <!-- &#xe692; -->
          <i v-show="classCount" class="ml-8 c-006AFE iconfont font-38"
            >&#xe610;</i
          >
        </div>
        <div>
          <common-button
            class="font-24"
            :styles="'font-24'"
            width="95"
            height="32"
            @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import API from '@/api/addressbook'
import {
  commonSearchInputBox,
  commonNodeNav,
  commonHeadImg,
  commonButton,
  commonCheckbox
} from '@/components/commonAddressBook'
import iAPI from '@/api'
import {
  getItem,
  getLocalItem,
  removeItem,
  setLeft,
  removeLeft,
  pushNullUrl
} from '@/utils/comUtils'
import {
  mcConfirm,
  mcShowPreloader,
  mcHidePreloader,
  mcAlert,
  mcToast
} from '@/utils/mcSdkUtils'

import {} from '@/utils/constUtils'

export default {
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonHeadImg,
    commonButton,
    commonCheckbox
  },
  props: {},
  data() {
    return {
      nodeNav: [], // 导航栏部门节点对象数组
      currentDepts: [], // 当前展示部门节点列表
      currentStudents: [], // 当前展示成员节点列表
      // 成员搜索相关
      isFocus: false, // 搜索框是否聚焦
      searchKey: '', // 搜索学生姓名关键字
      searchNodes: [], // 当前搜索学生姓名列表
      showSelectDetail: false, // 展示选择详情
      selectedData: [], // 已选择的数据
      sandboxStatus: 1, // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 已坏掉（处理数据异常） 8 已关闭
      parentId: '', // 父节点id
      classList: [], // 已选班级
      classIndex: 0, // 当前班级
      pageNum: 50, // 分页页码
      classParam: [], // 查人参数
      selectedNodes: [], // 已选部门列表
      clicking: false,
      clearNodesList: [],
      selDeptDingIds: [],
      selStudentDingIds: [],
      isOperateSelect: 0, // 0 未操作 1: 部门
      //////
      treeNodes: [],
      treeId: '',
      innerCampusId: '',
      initTreeId: {},
      showConfirm: false,
      clearConfirm: null
    }
  },
  computed: {
    // 计算是否展示全选
    computedIsShowSelectAll() {
      let _result = true
      // 显示搜索学生姓名 || 无部门
      if (
        this.searchKey ||
        (this.treeNodes && this.treeNodes.length === 0) ||
        (this.treeNodes && this.treeNodes.length && this.treeNodes[0].level)
      ) {
        _result = false
      }
      return _result
    },
    // 计算禁用全选
    computedIsDisabledSelectAll() {
      let _result = false
      if (this.treeNodes && this.treeNodes.length) {
        let _tag = true
        this.treeNodes.forEach(item => {
          if (item.classCnt) {
            _tag = false
          }
        })
        _tag && (_result = true)
      }
      return _result
    },
    // 计算全选是否勾选
    compuedIsSelectedAll() {
      let _isSelectAll = true
      if (this.treeNodes && this.treeNodes.length) {
        this.treeNodes.forEach(item => {
          if (!item.selectStatus) {
            _isSelectAll = false
          }
        })
      }
      return _isSelectAll
    },
    computedSelectedDept() {
      return this.selectedNodes.filter(item => item.type !== 3)
    },
    computedSelectedClass() {
      return this.selectedNodes.filter(item => item.type === 3)
    }
  },
  watch: {},
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
  },
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    async init() {
      await this.squirrelDeviceModelCampusClassCount()
      this.methodInitNodeNav()
      if (
        this.innerCampusId &&
        this.treeIds &&
        this.treeIds[this.innerCampusId]
      ) {
        this.initTreeId[this.innerCampusId] = this.treeIds[this.innerCampusId]
      }
    },
    // 初始化数据
    initData() {
      this.parentId = '' // 父节点id
      this.searchKey = ''
      this.searchNodes = []
    },
    // 搜索框聚焦
    async handlerToFocusSearch() {
      this.isFocus = true
      await this.addressChangeSelections()
    },
    // 搜索部门
    async handlerToSearch(searchKey) {
      await this.addressChangeSelections()
      this.searchKey = searchKey
      if (!searchKey) {
        if (this.treeNodes && this.treeNodes.length) {
          await this.squirrelClassTreeSubNodes()
        }
        return
      }
      this.squirrelClassTreeSearch()
    },
    // 获取子部门/学生
    async handlerToGetSubNodes(node) {
      if (this.clicking) {
        return
      }
      this.clicking = true
      if (node.level === 1) {
        if (this.innerCampusId && this.innerCampusId !== node.campusId) {
          if (this.classCount) {
            mcConfirm({
              title: '注意事项',
              msg: '通话模式不支持跨校区使用，切换校区后将清空当前选中范围，确认切换？'
            })
              .then(async btnIndex => {
                if (btnIndex === 1) {
                  this.handlerChangeCampus(node)
                } else {
                  this.clicking = false
                }
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          } else {
            this.handlerChangeCampus(node)
          }
        } else {
          this.innerCampusId = node.campusId
          this.parentId = ''
          if (!this.campusId) {
            this.campusId = node.campusId
            await this.classTreeCreate(this.innerCampusId)
          }
          await this.addressChangeSelections()
          await this.squirrelClassTreeSubNodes()
          this.methodUpdateNodeNav(node)
          this.clicking = false
        }
      } else {
        this.parentId = node.deptDingId
        await this.addressChangeSelections()
        await this.squirrelClassTreeSubNodes()
        this.methodUpdateNodeNav(node)
        this.clicking = false
      }
    },
    // 创建树
    async classTreeCreate(_campusId, init = false) {
      if (this.treeIds && this.treeIds[_campusId]) {
        this.treeId = this.treeIds[_campusId]
      } else {
        await this.squirrelClassTreeCreate(init)
      }
    },
    // 切换校区
    async handlerChangeCampus(node) {
      await this.squirrelClassTreeUnselectAll()
      this.initData()
      this.innerCampusId = node.campusId
      this.parentId = ''
      await this.classTreeCreate(this.innerCampusId)
      await this.addressChangeSelections()
      await this.squirrelClassTreeSubNodes()
      this.methodUpdateNodeNav(node)
      this.clicking = false
    },
    // 判断学生是否勾选
    handlerIsStudentSelected(type) {
      if (+type === 1 || +type === 3) {
        return true
      }
      return false
    },
    // 切换部门勾选状态
    async handlerChangeClassSelected(node, disabled, keywords) {
      if (disabled) {
        return
      }
      if (node.level === 1) {
        if (this.innerCampusId && this.innerCampusId !== node.campusId) {
          if (this.classCount) {
            mcConfirm({
              title: '注意事项',
              msg: '通话模式不支持跨校区使用，切换校区后将清空当前选中范围，确认切换？'
            })
              .then(async btnIndex => {
                if (btnIndex === 1) {
                  this.handlerChangeCampusNext(node, disabled, keywords)
                } else {
                  this.clicking = false
                }
              })
              .catch(err => {
                console.log('unhandledrejection', err)
              })
          } else {
            this.handlerChangeCampusNext(node, disabled, keywords)
          }
        } else {
          this.innerCampusId = node.campusId
          this.parentId = ''
          if (!this.campusId) {
            this.campusId = node.campusId
            await this.classTreeCreate(this.innerCampusId)
          }
          await this.handlerOperSelect(node, disabled, keywords)
          await this.addressChangeSelections()
        }
      } else {
        this.handlerOperSelect(node, disabled, keywords)
      }
    },
    // 切换校区查看子部门
    async handlerChangeCampusNext(node, disabled, keywords) {
      await this.squirrelClassTreeUnselectAll()
      this.treeNodes.forEach(n => {
        if (this.innerCampusId === n.campusId) {
          n.selectStatus = false
          n.classSelCnt = 0
          this.classCount = 0
        }
      })
      this.initData()
      this.innerCampusId = node.campusId
      this.parentId = ''
      await this.classTreeCreate(this.innerCampusId)
      await this.handlerOperSelect(node, disabled, keywords)
      await this.addressChangeSelections()
    },
    handlerOperSelect(node, disabled, keywords) {
      this.isOperateSelect = 1
      if (node.selectStatus) {
        this.classCount = this.classCount - node.classSelCnt
        node.classSelCnt = 0
      } else {
        this.classCount = this.classCount + node.classCnt - node.classSelCnt
        node.classSelCnt = node.classCnt
      }
      node.selectStatus = !node.selectStatus
      node.isOperate = true
      keywords &&
        this.addressChangeSelections(false, true)
          .then(res => {
            this.keywords = keywords
            this.squirrelClassTreeSearch(keywords)
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
    },
    // 获取勾选项
    getSelectedIds(isSearch) {
      this.selDeptDingIds = []
      if (!this.isOperateSelect) {
        return
      }
      let _nodes = this.treeNodes
      if (isSearch) {
        _nodes = this.searchNodes
      }
      if (_nodes && _nodes.length) {
        _nodes.forEach(item => {
          if (item.isOperate) {
            this.selDeptDingIds.push({
              deptDingId: item.deptDingId,
              selected: item.selectStatus
            })
          }
        })
      }
    },
    // 全选操作
    async handlerToChangeSelections() {
      if (this.computedIsDisabledSelectAll) {
        return
      }
      this.handlerOperSelectAll()
    },
    handlerOperSelectAll() {
      let _isSelected = this.compuedIsSelectedAll
      let _memberCount = this.classCount
      this.isOperateSelect = 1
      this.treeNodes.forEach(item => {
        item.isOperate = true
        _isSelected && item.selectStatus && (_memberCount -= item.classCnt)
        !_isSelected &&
          !item.selectStatus &&
          (_memberCount += item.classCnt - item.classSelCnt)
        item.classSelCnt = _isSelected ? 0 : item.classCnt
        item.selectStatus = !_isSelected
      })
      this.classCount = _memberCount
    },
    // 查看已选学生
    async handlerViewDetail() {
      if (!this.classCount) {
        return
      }
      mcShowPreloader()
      await this.addressChangeSelections()
      this.selectedNodes = []
      await this.squirrelClassTreeGetSelectedNodes()
      this.showSelectDetail = true
    },
    // 获取已选学生班级分页
    handlerGetClassPage() {
      let _num = 0
      this.classParam = []
      this.classList &&
        this.classList.length &&
        this.classList.some((item, index) => {
          if (_num >= this.pageNum) {
            return false
          }
          this.classIndex = index + 1
          _num += item.selStudentCnt
          this.classParam.push(item.classDingId)
        })
      this.classList.splice(0, this.classIndex)
    },
    // 删除已选部门
    clearNodes(item) {
      this.clearNodesList.push({ deptDingId: item.deptDingId, selected: false })
      this.selectedNodes.forEach((itm, index) => {
        if (itm.deptDingId === item.deptDingId) {
          this.selectedNodes.splice(index, 1)
        }
      })
    },
    // 查看已选 确认
    async confirmDetail() {
      if (this.clearNodesList.length) {
        await this.addressChangeSelections(true)
        if (!this.searchKey) {
          if (this.nodeNav && this.nodeNav.length > 1) {
            await this.squirrelClassTreeSubNodes()
          } else {
            await this.squirrelDeviceModelCampusClassCount()
          }
        } else {
          await this.squirrelClassTreeSearch()
        }
        this.clearNodesList = []
      }
      this.showSelectDetail = false
    },
    // 查看已选 清空
    clearData() {
      const that = this
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选班级`,
        onConfirm() {
          that.squirrelClassTreeUnselectAll()
          that.showSelectDetail = false
          that.initData()
          that.init()
        }
      }).show()
    },
    // 初始化导航栏
    methodInitNodeNav({ name, deptId = '' } = {}) {
      let _name =
        this.corpName ||
        (getLocalItem(`CURRENT_CAPMUS_${getItem('TOKEN').orgId}`) || {}).name ||
        '通讯录'
      let _node = {
        deptName: _name, // name ||
        deptId: deptId,
        type: 0
      }
      this.nodeNav = [_node]
    },
    // 更新导航栏
    methodUpdateNodeNav(node, isAdd = true) {
      if (isAdd) {
        this.nodeNav.push({
          deptName: node.deptName,
          deptId: node.deptDingId,
          type: node.type
        })
      } else {
        let _index = this.nodeNav.findIndex(item => item.deptId === node.deptId)
        this.nodeNav = this.nodeNav.slice(0, _index + 1)
      }
    },
    // 返回导航栏
    async handlerBackToNode(node) {
      await this.addressChangeSelections()
      this.methodUpdateNodeNav(node, false)
      this.parentId = node.deptId || ''
      if (node.deptId === '') {
        this.campusId = this.innerCampusId
        await this.squirrelDeviceModelCampusClassCount()
      } else {
        await this.squirrelClassTreeSubNodes()
      }
    },
    // 点击确认 关闭选人组件
    async handlerToSubmit() {
      if (this.clicking) {
        return
      }
      await this.addressChangeSelections()
      this.clicking = true
      const _treeIds = this.treeIds || {}
      Object.keys(_treeIds).forEach(async item => {
        await this.squirrelClassTreeCommit(item, _treeIds[item])
      })
      await this.squirrelClassTreeGetSelectedNodes()
      const _result = {
        treeIds: this.treeIds,
        treeId: this.treeId,
        campusId: this.innerCampusId || this.campusId,
        deptDingId: [],
        classCount: 0,
        nodes: this.selectedNodes
      }
      this.selectedNodes.forEach(node => {
        _result.classCount += node.data.classSelCnt
        _result.deptDingId.push(node.deptDingId)
      })
      if (!_result.classCount) {
        this.clicking = false
        return mcToast({ msg: '请选择' })
      }
      this.close(_result)
    },
    // 回退拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(btnIndex => {
            if (btnIndex === 1) {
              mcHidePreloader()
              const _treeIds = this.treeIds || {}
              Object.keys(_treeIds).forEach(async item => {
                await this.squirrelClassTreeRollback(item, _treeIds[item])
              })
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 钉钉返回按钮空处理事件(防止钉钉返回按钮监听事件移除后按钮失效)
    handlerClickBackbutton(e) {
      let _isNeedRemove = getItem('IS_IN_ADDRESSBOOK')
      if (_isNeedRemove) {
        // 在AddressBook组件内时，阻止钉钉返回按钮默认动作，并移除此防止点击返回按钮失效事件，改为绑定监听事件
        removeItem('IS_BIND_BACK_EVENT')
        document.removeEventListener(
          'backbutton',
          this.handlerClickBackbutton,
          true
        )
        e && e.preventDefault()
      }
    },
    // 设备模式-获取所有校区以及校区下的班级数量
    squirrelDeviceModelCampusClassCount() {
      return new Promise((resolve, reject) => {
        iAPI
          .squirrelDeviceModelCampusClassCount({
            campusId: this.campusId,
            deviceSn: this.deviceSn,
            operUserRoleTypes: this.operUserRoleTypes
          })
          .then(async res => {
            let _res = res || []
            _res.forEach(node => {
              node.deptName = node.campusName
              node.classCnt = node.classCount
              node.deptDingId = node.campusId
              node.hasChildren = !!node.classCount
              node.level = 1
              node.classSelCnt =
                node.campusId === this.campusId ? this.classCount : 0
              node.selectStatus =
                node.campusId === this.campusId &&
                node.classCount === this.classCount
            })
            this.innerCampusId = this.innerCampusId || this.campusId
            if (this.onlyThisCampus) {
              this.treeNodes = _res.filter(
                item => item.deptDingId === this.innerCampusId
              )
            } else {
              this.treeNodes = _res
            }
            if (!this.treeId && this.campusId) {
              await this.classTreeCreate(this.campusId, true)
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 创建树API
    squirrelClassTreeCreate(init) {
      return new Promise((resolve, reject) => {
        const _campusId = init ? this.campusId : this.innerCampusId
        API.squirrelClassTreeCreate({
          campusId: _campusId,
          operUserRoleTypes: this.operUserRoleTypes,
          deviceMode: this.deviceMode,
          deviceSn: this.deviceSn
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            if (init) {
              this.initTreeId[_campusId] = res
            }
            this.treeIds[_campusId] = res
            this.treeId = res
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查树节点信息API
    squirrelClassTreeSubNodes() {
      return new Promise((resolve, reject) => {
        const _param = {
          campusId: this.innerCampusId || this.campusId,
          operUserRoleTypes: this.operUserRoleTypes,
          parentNodeId: this.parentId,
          treeId: this.treeId
        }
        _param.parentNodeId =
          this.parentId === _param.campusId ? '' : this.parentId
        API.squirrelClassTreeSubNodes(_param)
          .then(res => {
            if (res && res.result === 'ME01000711000') {
              mcAlert({ msg: '页面已过期，重新进入' })
                .then(() => {
                  window.location.hash = '#/'
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
              return
            }
            let _res = res || []
            _res.forEach(node => {
              node.classCnt = node.data.classCnt
              node.classSelCnt = node.data.classSelCnt
              node.selectStatus =
                node.data.selectStatus === 'YES' ||
                node.data.selectStatus === 'PRE_SELECT'
            })
            this.treeNodes = _res
            this.searchNodes = []
            mcHidePreloader()
            resolve(res)
          })
          .catch(err => {
            mcHidePreloader()
            console.log(err)
          })
      })
    },
    // 勾选 API
    addressChangeSelections(type, isSearch) {
      this.getSelectedIds(isSearch)
      const _deptSelectionChanges = type
        ? this.clearNodesList
        : this.selDeptDingIds
      return new Promise((resolve, reject) => {
        if (_deptSelectionChanges && _deptSelectionChanges.length) {
          API.squirrelClassTreeChangeSelection({
            campusId: this.innerCampusId || this.campusId,
            operUserRoleTypes: this.operUserRoleTypes,
            treeId: this.treeId,
            deptSelectionChanges: _deptSelectionChanges
          })
            .then(res => {
              if (res && res.result === 'ME01000711000') {
                mcAlert({
                  msg: '页面已过期，重新进入'
                })
                  .then(() => {
                    window.location.hash = '#/'
                  })
                  .catch(err => {
                    console.log('unhandledrejection', err)
                  })
                return
              }
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              this.isOperateSelect = 0
              this.classCount = res.classSelCnt
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          this.isOperateSelect = 0
          resolve(0)
        }
      })
    },
    // 清除所有已选择API
    squirrelClassTreeUnselectAll() {
      return new Promise((resolve, reject) => {
        API.squirrelClassTreeUnselectAll({
          campusId: this.innerCampusId || this.campusId,
          operUserRoleTypes: this.operUserRoleTypes,
          treeId: this.treeId
        })
          .then(res => {
            if (res && res.result === 'ME01000711000') {
              mcAlert({ msg: '页面已过期，重新进入' })
                .then(() => {
                  window.location.hash = '#/'
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
              return
            }
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            this.classCount = res.classSelCnt
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询已选部门列表API
    squirrelClassTreeGetSelectedNodes() {
      if (this.treeId) {
        return new Promise((resolve, reject) => {
          API.squirrelClassTreeGetSelectedNodes({
            campusId: this.innerCampusId || this.campusId,
            operUserRoleTypes: this.operUserRoleTypes,
            treeId: this.treeId,
            type: 1
          })
            .then(res => {
              if (res && res.result === 'ME01000711000') {
                mcAlert({
                  msg: '页面已过期，重新进入'
                })
                  .then(() => {
                    window.location.hash = '#/'
                  })
                  .catch(err => {
                    console.log('unhandledrejection', err)
                  })
                return
              }
              let _res = res || []
              this.selectedNodes = _res
              mcHidePreloader()
              resolve(_res)
            })
            .catch(err => {
              console.log(err)
              mcHidePreloader()
            })
        })
      }
    },
    // 搜索部门API
    squirrelClassTreeSearch() {
      return new Promise((resolve, reject) => {
        API.squirrelClassTreeSearch({
          campusId: this.innerCampusId || this.campusId,
          operUserRoleTypes: this.operUserRoleTypes,
          treeId: this.treeId,
          limit: 30,
          keywords: this.searchKey
        })
          .then(res => {
            if (res && res.result === 'ME01000711000') {
              mcAlert({ msg: '页面已过期，重新进入' })
                .then(() => {
                  window.location.hash = '#/'
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
              return
            }
            let _res = res || []
            _res.forEach(node => {
              node.classCnt = node.data.classCnt
              node.classSelCnt = node.data.classSelCnt
              node.selectStatus =
                node.data.selectStatus === 'YES' ||
                node.data.selectStatus === 'PRE_SELECT'
            })
            this.searchNodes = _res
            mcHidePreloader()
            resolve(_res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
      })
    },
    // 提交预选项API
    squirrelClassTreeCommit(campusId, treeId) {
      const _campusId = this.innerCampusId || this.campusId
      return new Promise((resolve, reject) => {
        API.squirrelClassTreeCommit({
          campusId: campusId,
          treeId: treeId,
          operUserRoleTypes: this.operUserRoleTypes
        })
          .then(res => {
            if (res && res.result === 'ME01000711000') {
              mcAlert({ msg: '页面已过期，重新进入' })
                .then(() => {
                  window.location.hash = '#/'
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
              return
            }
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            _campusId === campusId && (this.classCount = res.classSelCnt)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 取消预选项
    squirrelClassTreeRollback(campusId, treeId) {
      return new Promise((resolve, reject) => {
        const _campusId = this.innerCampusId || this.campusId
        API.squirrelClassTreeRollback({
          campusId: campusId,
          treeId: treeId,
          operUserRoleTypes: this.operUserRoleTypes
        })
          .then(res => {
            if (res && res.result === 'ME01000711000') {
              mcAlert({ msg: '页面已过期，重新进入' })
                .then(() => {
                  window.location.hash = '#/'
                })
                .catch(err => {
                  console.log('unhandledrejection', err)
                })
              return
            }
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            _campusId === campusId && (this.classCount = res.classSelCnt)
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 通用班级树,批量取消预选项
    squirrelClassTreeBatchRollback() {
      const _treeIds = Object.values(this.treeIds || {})
      if (_treeIds && _treeIds.length) {
        return new Promise((resolve, reject) => {
          const _campusId = this.innerCampusId || this.campusId
          API.squirrelClassTreeBatchRollback({
            campusId: _campusId,
            treeIds: _treeIds,
            operUserRoleTypes: this.operUserRoleTypes
          })
            .then(res => {
              if (res && res.result === 'ME01000711000') {
                mcAlert({
                  msg: '页面已过期，重新进入'
                })
                  .then(() => {
                    window.location.hash = '#/'
                  })
                  .catch(err => {
                    console.log('unhandledrejection', err)
                  })
                return
              }
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              this.classCount = res.classSelCnt || 0
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        })
      }
    },
    // 通用班级树,批量提交预选项
    squirrelClassTreeBatchCommit() {
      const _treeIds = Object.values(this.treeIds || {})
      if (_treeIds && _treeIds.length) {
        return new Promise((resolve, reject) => {
          API.squirrelClassTreeBatchCommit({
            campusId: this.innerCampusId || this.campusId,
            treeIds: _treeIds,
            operUserRoleTypes: this.operUserRoleTypes
          })
            .then(res => {
              if (res && res.result === 'ME01000711000') {
                mcAlert({
                  msg: '页面已过期，重新进入'
                })
                  .then(() => {
                    window.location.hash = '#/'
                  })
                  .catch(err => {
                    console.log('unhandledrejection', err)
                  })
                return
              }
              if ((res && res.result && res.result !== '0') || res === null) {
                return false
              }
              this.classCount = res.classSelCnt
              resolve(res)
            })
            .catch(err => {
              console.log(err)
            })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 22;
  overflow-y: scroll;
}

.node-list {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 2px;
}
.group-title {
  padding: 18px 16px 9px;
}
</style>
